import _ from "lodash";
import React from "react";
import { FormattedMessage } from "react-intl";

import { useForm } from "@sportal/cdk";
import {
  CommonModalFooter,
  CommonModalHeader,
  ModalDialog,
  ModalHint,
} from "../../../../../components";
import {
  DeviceDialogInput,
  makeProfilePickerItems,
  ProfilesPicker,
  useDeviceIdValidator,
  useDeviceNameValidator,
} from "../deviceForm";
import { useIntlTranslate } from "../../../../../hooks";

export function AddDeviceDialog({ modal, profiles, devices }) {
  const translate = useIntlTranslate();
  const profileSelectItems = makeProfilePickerItems(profiles, translate);

  const firstAvailableProfileItem = _.find(profileSelectItems, {
    disabled: false,
  });
  const form = useForm({
    name: "",
    mac: "",
    profileName: firstAvailableProfileItem.value,
  });

  const validateName = useDeviceNameValidator(devices);
  const validateMac = useDeviceIdValidator(devices);

  const setError = (name, error) => {
    if (!_.isEmpty(error)) {
      form.setError(`${name}`, error);
    } else {
      form.setError(`${name}`, null);
    }
  };

  const changeName = (name) => {
    const nameError = validateName(_.trim(name));

    form.set("name", name);
    setError("name", nameError);
  };

  const changeMac = (mac) => {
    const macError = validateMac(mac);

    form.set("mac", mac);
    setError("mac", macError);
  };

  const submit = () => {
    modal.resolve({
      name: _.trim(form.values.name),
      mac: form.values.mac,
      profileName: form.values.profileName,
    });
  };

  const close = () => modal.reject();
  const isSubmitDisabled =
    _.isEmpty(form.values.mac) || _.isEmpty(_.trim(form.values.name));

  return (
    <ModalDialog
      className="add-device-modal"
      disabled={!form.didFormChange() || form.hasErrors() || isSubmitDisabled}
      submitHandler={() => submit(modal)}
      rejectHandler={close}
    >
      <CommonModalHeader>
        <FormattedMessage id="add_device_manually" />
      </CommonModalHeader>
      <ModalDialog.Body>
        <ModalHint>
          <FormattedMessage id="add_device_message" />
        </ModalHint>
        <DeviceDialogInput
          label="device_name"
          placeholder="enter_device_name"
          value={form.values.name}
          onChange={changeName}
          error={form.errors.name}
          autoFocus
          maxLength="30"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck="false"
        />
        <DeviceDialogInput
          label="mac_address"
          placeholder="mac_address_placeholder"
          value={form.values.mac}
          onChange={changeMac}
          error={form.errors.mac}
          maxLength="17"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck="false"
          inputMode="verbatim"
        />
        <ProfilesPicker
          label={<FormattedMessage id="profile" />}
          items={profileSelectItems}
          selected={form.values.profileName}
          onChange={(value) => form.set("profileName", value)}
        />
      </ModalDialog.Body>
      <CommonModalFooter submitMessage={<FormattedMessage id="add_device" />} />
    </ModalDialog>
  );
}
